import { getDatabase, push, ref, set } from 'firebase/database';
import { initFb } from './config';
import {
  getDownloadURL,
  getStorage,
  ref as sRef,
  uploadBytes,
} from 'firebase/storage';

let databaseInstance = null,
  storageInstance = null;

const FIREBASE_HARDCODED_CONFIG = {
  apiKey: 'YOUR_API_KEY_HERE',
  databaseURL: 'https://YOUR_DATABASE_://firebaseio.com',
  projectId: 'YOUR_PROJECT_ID_HERE',
  storageBucket: 'YOUR_STORAGE_BUCKET_://appspot.com',
};

document.addEventListener('DOMContentLoaded', () => {
  initializeFirebasePipeline();
  document
    .getElementById('upload-btn')
    .addEventListener('click', executeDatabaseAndCloudUpload);
  document
    .getElementById('print-local-btn')
    .addEventListener('click', () => window.print());
  document
    .getElementById('reset-btn')
    .addEventListener('click', resetFormWorkspace);
  initializeSignaturePad('canvas-landlord', 'clear-landlord', '#0f2d59');
  initializeSignaturePad('canvas-officer', 'clear-officer', '#b45309');
});

function setDefaultSystemDates() {
  const today = new Date().toISOString().split('T');
  document.getElementById('voucher-date').value = today[0];
  document.getElementById('sig-date').value = today[0];
}

function initializeFirebasePipeline() {
  //   const cfg = FIREBASE_HARDCODED_CONFIG;
  //   if (cfg.apiKey.includes('HERE')) {
  //     document.getElementById('status-display').innerText =
  //       'ERROR: Please update app.js with your hardcoded Firebase credentials.';
  //     return;
  //   }
  try {
    //const app = initializeApp(cfg);
    initFb();
    databaseInstance = getDatabase();
    storageInstance = getStorage();
    setDefaultSystemDates();
    generateAndSetNewVoucherId();
  } catch (e) {
    alert('Initialization Fail: ' + e.message);
  }
}

function generateAndSetNewVoucherId() {
  if (!databaseInstance) return;
  const uniqueVoucherKey = push(ref(databaseInstance, 'DISB')).key;
  document.getElementById('data-voucherNum').value = uniqueVoucherKey;
  document.getElementById('status-display').innerText =
    'Status: Connected. Modular Voucher ID ' + uniqueVoucherKey + ' allocated.';
}

function initializeSignaturePad(id, btnId, color) {
  const cvs = document.getElementById(id),
    ctx = cvs.getContext('2d'),
    btn = document.getElementById(btnId);
  function resize() {
    const r = cvs.getBoundingClientRect();
    cvs.width = r.width;
    cvs.height = r.height;
    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
  }
  window.addEventListener('resize', resize);
  setTimeout(resize, 400);
  let draw = false;
  const pos = (e) => {
    const r = cvs.getBoundingClientRect();
    return {
      x: (e.touches ? e.touches.clientX : e.clientX) - r.left,
      y: (e.touches ? e.touches.clientY : e.clientY) - r.top,
    };
  };
  const start = (e) => {
    draw = true;
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
    e.preventDefault();
  };
  const move = (e) => {
    if (draw) {
      const p = pos(e);
      ctx.lineTo(p.x, p.y);
      ctx.stroke();
    }
    e.preventDefault();
  };
  cvs.addEventListener('mousedown', start);
  cvs.addEventListener('mousemove', move);
  window.addEventListener('mouseup', () => (draw = false));
  cvs.addEventListener('touchstart', start, { passive: false });
  cvs.addEventListener('touchmove', move, { passive: false });
  window.addEventListener('touchend', () => (draw = false));
  btn.addEventListener('click', () =>
    ctx.clearRect(0, 0, cvs.width, cvs.height),
  );
}

async function executeDatabaseAndCloudUpload() {
  if (!databaseInstance || !storageInstance) return;

  // Reset any previous red validation highlights
  document
    .querySelectorAll('input, select')
    .forEach((el) => (el.style.borderColor = ''));

  // Define audit critical mandatory fields mapped by ID
  const requiredFieldIds = [
    'data-wireRef',
    'data-recipName',
    'data-recipId',
    'data-recipBank',
    'data-benefName',
    'data-address',
    'data-category',
    'data-description',
    'data-amtUsd',
  ];

  let missingFieldsCount = 0;
  requiredFieldIds.forEach((id) => {
    const el = document.getElementById(id);
    if (!el || !el.value.trim()) {
      el.style.borderColor = '#ef4444'; // Highlight missing inputs in bright red
      missingFieldsCount++;
    }
  });

  const txt = document.getElementById('status-display');

  if (missingFieldsCount > 0) {
    txt.style.color = '#dc2626';
    txt.innerText = `VALIDATION FAILED: ${missingFieldsCount} required compliance field(s) are missing or blank.`;
    alert(
      'Compliance Error:\n\nAll organizational, recipient, beneficiary, and financial fields are mandatory for international audit trails. Blank entries are not permitted.',
    );
    return; // Halt system code loop routing execution
  }

  const vNum = document.getElementById('data-voucherNum').value;
  txt.style.color = '#1e40af';
  txt.innerText = 'Status: Exporting transactional schema components...';

  const payload = {
    voucherId: vNum,
    voucherDate: document.getElementById('voucher-date').value,
    wireRef: document.getElementById('data-wireRef').value,
    signDate: document.getElementById('sig-date').value,
    payeeName: document.getElementById('data-recipName').value,
    payeeId: document.getElementById('data-recipId').value,
    payeeBank: document.getElementById('data-recipBank').value,
    doneeName: document.getElementById('data-recipName').value,
    doneeAddress: document.getElementById('data-address').value,
    program: document.getElementById('data-category').value,
    purpose: document.getElementById('data-description').value,
    usdAmount: document.getElementById('data-amtUsd').value,
    localCurrency: (
      document.getElementById('data-currencyCode').value || ''
    ).toUpperCase(),
    localAmount: document.getElementById('data-amtLocal').value,
    date: new Date().getTime(),
    timestamp: new Date().toISOString(),
  };

  try {
    await set(ref(databaseInstance, 'DISB/' + vNum), payload);
    txt.innerText = 'Status: Compiling PDF matrix...';

    const blob = await html2pdf()
      .set({
        margin: 0.2,
        filename: vNum + '_Voucher.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      })
      .from(document.getElementById('invoice-render-target'))
      .output('blob');
    txt.innerText = 'Status: Uploading PDF...';

    const fileRef = sRef(
      storageInstance,
      `DISBFiles/${vNum}/${vNum}_Voucher.pdf`,
    );
    await uploadBytes(fileRef, blob);

    const url = await getDownloadURL(fileRef);
    await set(push(ref(databaseInstance, `disbFiles/${vNum}`)), url);

    const fIn = document.getElementById('additional-files-input');
    if (fIn.files.length > 0) {
      for (let i = 0; i < fIn.files.length; i++) {
        txt.innerText = `Status: Processing attachment [${i + 1}/${fIn.files.length}]...`;
        const attachmentRef = sRef(
          storageInstance,
          `DISBFiles/${vNum}/attachments/${Date.now()}_${fIn.files[i].name}`,
        );
        await uploadBytes(attachmentRef, fIn.files[i]);
        const aUrl = await getDownloadURL(attachmentRef);
        await set(push(ref(databaseInstance, `disbFiles/${vNum}`)), aUrl);
      }
    }

    document.querySelectorAll('input, select').forEach((el) => {
      el.setAttribute('disabled', 'true');
      el.style.backgroundColor = '#e2e8f0';
    });
    document.getElementById('upload-btn').setAttribute('disabled', 'true');
    document.getElementById('upload-btn').style.backgroundColor = '#64748b';
    document.getElementById('clear-landlord').style.display = 'none';
    document.getElementById('clear-officer').style.display = 'none';
    document.getElementById('attachment-container').style.opacity = '0.5';
    txt.style.color = '#16a34a';
    txt.innerText =
      'SUCCESS: Modular upload complete and interface form locked.';
    alert('All files and database structures synchronized successfully.');
  } catch (err) {
    txt.style.color = '#dc2626';
    txt.innerText = 'ERROR: ' + err.message;
  }
}

function resetFormWorkspace() {
  if (
    !confirm(
      'Are you sure you want to clear all inputs and start a brand new voucher? Unsaved data will be lost.',
    )
  )
    return;
  document.querySelectorAll('input, select').forEach((el) => {
    if (
      el.id !== 'data-orgName' &&
      el.id !== 'data-ein' &&
      el.id !== 'data-orgEmail'
    )
      el.value = '';
    el.removeAttribute('disabled');
    el.style.backgroundColor = '#fff';
    el.style.borderColor = '';
  });
  const upBtn = document.getElementById('upload-btn');
  upBtn.removeAttribute('disabled');
  upBtn.style.backgroundColor = '#0f2d59';
  document.getElementById('clear-landlord').style.display = 'block';
  document.getElementById('clear-officer').style.display = 'block';
  document.getElementById('attachment-container').style.opacity = '1';
  document.getElementById('status-display').style.color = '#1e40af';
  ['canvas-landlord', 'canvas-officer'].forEach((id) => {
    const c = document.getElementById(id);
    c.getContext('2d').clearRect(0, 0, c.width, c.height);
  });
  setDefaultSystemDates();
  generateAndSetNewVoucherId();
}
